// Utility function to map MIME types to file extensions
const mimeToExtensionMap = {
	'application/pdf': 'pdf',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
	'application/vnd.ms-excel': 'xls',
	'application/vnd.ms-excel.sheet.macroEnabled.12': 'xlsm',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
		'docx',
	'application/msword': 'doc',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation':
		'pptx',
	'application/vnd.ms-powerpoint': 'ppt',
	'text/csv': 'csv',
	'text/tab-separated-values': 'tsv',
	'image/jpeg': 'jpg',
	'image/png': 'png',
	'image/gif': 'gif',
	'image/bmp': 'bmp',
	'image/webp': 'webp',
	'image/svg+xml': 'svg',
	'audio/mpeg': 'mp3',
	'audio/wav': 'wav',
	'audio/ogg': 'ogg',
	'video/mp4': 'mp4',
	'video/x-msvideo': 'avi',
	'video/x-ms-wmv': 'wmv',
	'video/quicktime': 'mov',
	'application/zip': 'zip',
	'application/x-rar-compressed': 'rar',
	'application/x-7z-compressed': '7z',
	'application/x-tar': 'tar',
	'application/json': 'json',
	'application/xml': 'xml',
	'text/html': 'html',
	'text/plain': 'txt',
};

export function getExtensionFromMimeType(mimeType) {
	return mimeToExtensionMap[mimeType] || null;
}
